import { render, staticRenderFns } from "./SettingOptions.vue?vue&type=template&id=1feadfd6&"
import script from "./SettingOptions.vue?vue&type=script&lang=js&"
export * from "./SettingOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports